import { UTILS } from "../../utils";

var INFORM_DATA_MANAGER = {
    /**
     * 根据服务器返回数据获取前端通知列表数据
     * @param {服务器返回数据} data 
     */
    getInformListByData(data) {
        var resultList = [];
        if(data.length > 0) {
            data.forEach(element => {
                var titleText = element.f_type == 1 ? '被点赞' : '';
                    titleText = element.f_type == 2 ? '评论' : titleText;
                    titleText = element.f_type > 2 ? '百科管家' : titleText;
                var iconType = element.f_type == 1 ? 'good' : '';
                    iconType = element.f_type == 2 ? 'comment' : iconType;
                    iconType = element.f_type > 2 ? 'manager' : iconType;
                resultList.push({
                    id: element.id,
                    iconType: iconType,
                    titleText: titleText,
                    timeText: UTILS.getTimeInfoByTimeString(element.f_time),
                    msg: element.f_msg,
                    unread: element.isread == 0 ? true : false
                });
            })
        }
        return resultList;
    },
    /**
     * 根据通知id更新通知列表的数据的已读状态
     * @param {通知列表} informList 
     * @param {通知id的数组} informIdList 
     */
    updateInformListReadStatusByInformId(informList, informIdList) {
        informList.forEach((element, index) => {
            if(informIdList.indexOf(element.id.toString()) != -1) {
                informList[index].unread = false;
            }
        });
        return informList;
    },
    /**
     * 更新通知列表所有数据的已读状态
     * @param {通知列表} informList 
     */
    updateInformAllListReadStatusByInformId(informList) {
        informList.forEach((element, index) => {
            informList[index].unread = false;
        });
        return informList;
    }
}

export {
    INFORM_DATA_MANAGER
}